var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudioAndCam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 24,
    viewBox: "0 0 72 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4063 3.8906C55.7772 3.3342 56.4017 3 57.0704 3H62.9296C63.5983 3 64.2228 3.3342 64.5937 3.8906L66 6H67C68.6569 6 70 7.34315 70 9V18C70 19.6569 68.6569 21 67 21H53C51.3431 21 50 19.6569 50 18V9C50 7.34315 51.3431 6 53 6H54L55.4063 3.8906Z",
    stroke: "#00B349",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17C62.4853 17 64.5 14.9853 64.5 12.5C64.5 10.0147 62.4853 8 60 8C57.5147 8 55.5 10.0147 55.5 12.5C55.5 14.9853 57.5147 17 60 17Z",
    stroke: "#00B349",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 9H35V12H32V14H35V17H37V14H40V12H37V9Z",
    fill: "#00B349"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.5C4.5 15.366 7.85786 18.5 12 18.5C16.1421 18.5 19.5 15.366 19.5 11.5",
    stroke: "#00B349",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5C13.933 2.5 15.5 4.067 15.5 6V11C15.5 12.933 13.933 14.5 12 14.5C10.067 14.5 8.5 12.933 8.5 11V6C8.5 4.067 10.067 2.5 12 2.5Z",
    stroke: "#00B349",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19V21.5",
    stroke: "#00B349",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioAndCam);
export default __webpack_public_path__ + "static/media/audio-and-cam.cd8220f3.svg";
export { ForwardRef as ReactComponent };